export const environment = {
  production: true,
  buildId: '3485763248322351',
  configFile: 'config.json',
};
